/*
 * Authors: mariushirjanu
 * Created: 06/12/2016
 * Upgraded: 02/03/2023
 */
import { Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { ResizeService } from '../services/resize.service';
import { WindowPropertiesService } from '../services/window-properties.service';
import { MAIN_CONTAINER_ELEMENT } from '../../main/main.component';

const MAX_HEIGHT:number = 120;

@Directive({
  selector: '[maxHeight]'
})
export class MaxHeightDirective implements OnChanges, OnDestroy {
  @Input() public maxHeight; // empty
  @Input() public open:boolean;

  private element;

  constructor(
    private elementRef:ElementRef,
    private resizeService:ResizeService,
    private windowPropertiesService:WindowPropertiesService
  ) {
    this.element = this.elementRef.nativeElement;
    this.listen();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.open && !changes.open.isFirstChange()){
      this.open = changes.open.currentValue;
      setTimeout(() => { // give some time so that the popup has time to open in order to calculate the size
        this.resizer();
      });
    }
  }

  private listen():void {
    this.resizeService.addResizeEventListener(MAIN_CONTAINER_ELEMENT, () => {
      this.resizer();
    });
  }

  private resizer():void {
    if(this.open) {
      const windowHeight:number = this.windowPropertiesService.innerHeight();
      const objectTopPosition:number = this.element.getBoundingClientRect().top - $(window).scrollTop();
      const bottomMargin:number = 20;
      let max:number = windowHeight - objectTopPosition - bottomMargin;
      if (max < MAX_HEIGHT) {
        max = MAX_HEIGHT;
      }
      $(this.element).css('max-height', `${max}px`);
    }
  }

  public ngOnDestroy():void {
    this.resizeService.removeResizeEventListener(MAIN_CONTAINER_ELEMENT);
  }
}